import script from "./HeaderHeks.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderHeks.vue?vue&type=script&setup=true&lang=js"

import "./HeaderHeks.vue?vue&type=style&index=0&id=ce448264&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce448264"]])

export default __exports__